/*

  ______  _____   ______ _______  ______
 |_____/ |     | |  ____ |______ |_____/
 |    \_ |_____| |_____| |______ |    \_

 vehicle sales system

(c) 2006 - 2019 TCE <TCE-ITDevelopers@toyota-ce.com>

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

(function () {
    "use strict";

    angular
        .module("ROGER")
        .factory("retailTargetsService", RetailTargetsService);

    RetailTargetsService.$inject = ["graphService"];

    function RetailTargetsService(graphService) {
        var _data = undefined;
        var _widthOfRetailTargetsBox = 0;
        var _shiftDays = 1;
        var _retailTargets = null;
        var _periods = null;
        var _sumOfGraphData = {};
        var _translations = {};
        var _retailTargetsDataViewTable = [
            "CcPcPlan",
            "CcPcActual",
            "CcPcPlanAch",
            "CcCvPlan",
            "CcCvActual",
            "CcCvPlanAch",
            "RetPcPlan",
            "RetPcActual",
            "RetPcPlanAch",
            "RetCvPlan",
            "RetCvActual",
            "RetCvPlanAch"
        ];

        var service = {
            setData: setData,
            getData: getData,
            widthOfRetailTargetsBox: _widthOfRetailTargetsBox,
            processDataGraph: processDataGraph,
            processDataTable: processDataTable,
            getGraphData: getGraphData,
            getGraphPeriods: getGraphPeriods,
            getRetailTargetsPeriod: getRetailTargetsPeriod,
            getWidthOfRetailtargetsBox: getWidthOfRetailtargetsBox,
            createGraph: createGraph,
            getTableHeaders: getTableHeaders
        };

        return service;

        function getWidthOfRetailtargetsBox() {
            var retailTargetsBoxElm = document.getElementById("retailTargetsBox");
            if (retailTargetsBoxElm !== null) {
                return document.getElementById("retailTargetsBox").offsetWidth - 40;
            }
            return 0;
        }

        function setData(data) {
            _data = data;
        }

        function getData() {
            return _data;
        }

        function getGraphData() {
            return _retailTargets;
        }

        function getGraphPeriods() {
            return _periods;
        }

        function getTableHeaders() {
            return _retailTargetsDataViewTable;
        }

        function getRetailTargetsPeriod(dateIn, shiftDays) {
            if (angular.isUndefinedNullOrEmpty(shiftDays)) {
                shiftDays = _shiftDays;
            }
            var d;
            if (angular.isUndefinedNullOrEmpty(dateIn)) {
                var currentDate = new Date();
                currentDate.setDate(currentDate.getDate() - shiftDays);
                d = currentDate;
            } else if (angular.isDate(dateIn)) {
                d = dateIn;
            } else {
                d = new Date(dateIn);
            }

            var currentMonth = d.getMonth() + 1;
            var quarter = Math.ceil(currentMonth / 3);

            return {
                actualPeriod: (d.getFullYear() * 100) + currentMonth,
                beginPeriod: (d.getFullYear() * 100) + (quarter * 3 - 2),
                endPeriod: (d.getFullYear() * 100) + (quarter * 3),
                shiftDays: shiftDays,
                quarter: quarter,
                year: d.getFullYear()
            };
        }

        function createGraph(period) {
            if (_retailTargets !== null && typeof _retailTargets === "object" && _retailTargets.hasOwnProperty(period)) {
                graphService.removeGraph("#dealerTarget");
                graphService.setData(_retailTargets[period]);
                _widthOfRetailTargetsBox = getWidthOfRetailtargetsBox();
                graphService.renderGraph(_widthOfRetailTargetsBox, "#dealerTarget");
            }
        }

        function processDataGraph(periodIn, translations) {
            var periods = {};
            var targetsPeriods = {};

            _translations = translations;
            _sumOfGraphData = {};
            _data.forEach(function (target) {
                var period = target["PeriodPlan"].toString();
                if (target["PeriodPlan"] >= periodIn.beginPeriod && target["PeriodPlan"] <= periodIn.endPeriod) {
                    periods[period] = period.slice(-2) + "/" + period.substring(0, 4);
                    targetsPeriods[period] = [
                        getGraphLine(target, "CC PC", "CcPc"),
                        getGraphLine(target, "CC CV", "CcCv"),
                        getGraphLine(target, "RET PC", "RetPc"),
                        getGraphLine(target, "RET CV", "RetCv")
                    ];
                }
            });

            if (_data.length > 0) {
                countPercentageAchievement();
                var quarterPeriod = "Q" + periodIn.quarter + periodIn.year;
                periods[quarterPeriod] = "Q" + periodIn.quarter + "/" + periodIn.year;
                targetsPeriods[quarterPeriod] = [
                    getGraphLine(_sumOfGraphData, "CC PC", "CcPc", false),
                    getGraphLine(_sumOfGraphData, "CC CV", "CcCv", false),
                    getGraphLine(_sumOfGraphData, "RET PC", "RetPc", false),
                    getGraphLine(_sumOfGraphData, "RET CV", "RetCv", false)
                ];
            }

            _sumOfGraphData = {};
            _retailTargets = targetsPeriods;
            _periods = periods;
        }

        function getGraphLine(target, title, section, sum, format) {
            if (sum === undefined) {
                sum = true;
            }
            if (format === undefined) {
                format = null;
            }

            var result = {
                "title": title,
                "target": target[section + "Plan"],
                "actual": target[section + "Actual"],
                "format": format
            };

            switch (section) {
                default:
                    result["subtitle"] = _translations["Plan"] + " " + target[section + "Plan"];
                    result["percent"] = (target[section + "PlanAch"] * 100).toFixed(1);
                    break;
            }

            if (sum === true) {
                sumGraphData(target, section);
            }

            return result;
        }

        function sumGraphData(target, section) {
            switch (section) {
                default:
                    if (angular.isUndefinedNullOrEmpty(_sumOfGraphData[section + "Plan"])) {
                        _sumOfGraphData[section + "Plan"] = target[section + "Plan"];
                    } else {
                        _sumOfGraphData[section + "Plan"] += target[section + "Plan"];
                    }

                    if (angular.isUndefinedNullOrEmpty(_sumOfGraphData[section + "Actual"])) {
                        _sumOfGraphData[section + "Actual"] = target[section + "Actual"];
                    } else {
                        _sumOfGraphData[section + "Actual"] += target[section + "Actual"];
                    }
                    break;
            }
        }

        function countPercentageAchievement() {
            if (!angular.isUndefinedNullOrEmpty(_sumOfGraphData["CcPcPlan"]) && !angular.isUndefinedNullOrEmpty(_sumOfGraphData["CcPcActual"])) {
                _sumOfGraphData["CcPcPlanAch"] = (_sumOfGraphData["CcPcPlan"] !== 0) ? _sumOfGraphData["CcPcActual"] / _sumOfGraphData["CcPcPlan"] : 0;
            }

            if (!angular.isUndefinedNullOrEmpty(_sumOfGraphData["CcCvPlan"]) && !angular.isUndefinedNullOrEmpty(_sumOfGraphData["CcCvActual"])) {
                _sumOfGraphData["CcCvPlanAch"] = (_sumOfGraphData["CcCvPlan"] !== 0) ? _sumOfGraphData["CcCvActual"] / _sumOfGraphData["CcCvPlan"] : 0;
            }

            if (!angular.isUndefinedNullOrEmpty(_sumOfGraphData["RetPcPlan"]) && !angular.isUndefinedNullOrEmpty(_sumOfGraphData["RetPcActual"])) {
                _sumOfGraphData["RetPcPlanAch"] = (_sumOfGraphData["RetPcPlan"] !== 0) ? _sumOfGraphData["RetPcActual"] / _sumOfGraphData["RetPcPlan"] : 0;
            }

            if (!angular.isUndefinedNullOrEmpty(_sumOfGraphData["RetCvPlan"]) && !angular.isUndefinedNullOrEmpty(_sumOfGraphData["RetCvActual"])) {
                _sumOfGraphData["RetCvPlanAch"] = (_sumOfGraphData["RetCvPlan"] !== 0) ? _sumOfGraphData["RetCvActual"] / _sumOfGraphData["RetCvPlan"] : 0;
            }
        }

        function processDataTable(periodIn) {
            var dataResult = [];
            _data.forEach(function (target) {
                if (target["PeriodPlan"] >= periodIn.beginPeriod && target["PeriodPlan"] <= periodIn.endPeriod) {
                    dataResult.push(target);
                }
            });

            if (dataResult.length > 0) {
                _sumOfGraphData = {};
                dataResult.forEach(function (target) {
                    sumGraphData(target, "CcPc");
                    sumGraphData(target, "CcCv");
                    sumGraphData(target, "RetPc");
                    sumGraphData(target, "RetCv");
                });
                countPercentageAchievement();
                return dataResult.concat(_sumOfGraphData);
            }
            return [];
        }
    }
})();